export const USER_CLOSED_TICKET_STATUSES = ['closed'];

export function userCannotSendMoreMessages(status) {
  return USER_CLOSED_TICKET_STATUSES.includes(String(status || '').toLowerCase());
}

export function userMaySendFollowUp(status, messages) {
  if (userCannotSendMoreMessages(status)) return false;
  if (!Array.isArray(messages) || messages.length === 0) return false;
  const last = messages[messages.length - 1];
  return String(last.authorRole || '').toLowerCase() === 'admin';
}
